"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthInterceptor = void 0;
class AuthInterceptor {
    constructor(axiosInstance) {
        this.axiosInstance = axiosInstance;
    }
    setupInterceptor() {
        this.addRequestInterceptor();
    }
    addRequestInterceptor() {
        this.axiosInstance.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
            if (config.url.includes('v1/common/tx/im/uniqueSign')) {
                config.phpSpecial = true;
            }
            const headers = config.headers || {};
            const authHeader = config.setAuthorizationHeader;
            if (authHeader && !(headers === null || headers === void 0 ? void 0 : headers.Authorization) && config.requireAuth) {
                headers.Authorization =
                    typeof authHeader === 'function'
                        ? yield authHeader(config)
                        : authHeader;
            }
            config.headers = headers;
            return config;
        }));
    }
}
exports.AuthInterceptor = AuthInterceptor;
//# sourceMappingURL=AuthInterceptor.js.map